import React from 'react';
import PropTypes from 'prop-types';

const AddressCompanyNameCell = ({ prefix = '', addressCompanyName, invalid }) => {
  return (
    <div title={addressCompanyName} style={invalid ? { color: 'red' } : null}>
      {prefix}
      {addressCompanyName}
    </div>
  );
};

AddressCompanyNameCell.propTypes = {
  addressCompanyName: PropTypes.string,
};

export default AddressCompanyNameCell;
